export class DataInput {
  id: bigint;
  order: number;
  priority: number;
  orderno: number;
  orderpos: number;
  reference: string;
  project_reference: string;
  figure: string;
  barcode: string;
  mat_id: string;
  mat_name: string;
  mat_desc: string;
  stock_length: number;
  width: number;
  height: number;
  units: number;
  insertion_id: number;
  steps: string;
  date: any;
  easel: number;
  packing: number;
  route: number;
  group: string;
  lot: number;
  sequence: number;
  decoat: number;
  id_line: number;
  id_client: number;
  client: string;
  l: number;
  l1: number;
  l2: number;
  h: number;
  h1: number;
  h2: number;
  r: number;
  r2: number;
  r3: number;
  r4: number;
  b1: number;
  b2: number;
  b3: number;
  b4: number;
  dxf_name: string;
  dxf_points: any;
  dxf_w: number;
  dxf_h: number;
  oef_generated: boolean;
  oef_internal_polygons: any;
  oef_primitive_w: number;
  oef_primitive_h: number;
  oef_primitive_b1: number;
  oef_primitive_b2: number;
  oef_primitive_b3: number;
  oef_primitive_b4: number;
  oef_effective_area: number;
  oef_runtime_units: number;
  num_of: number;
  pos_of: number;
  paneno: number;
}
